import {useDispatch, useSelector} from "react-redux";
import {useFetch} from "../../services/useFetch";
import {API} from "../../services/api";
import {FIELD_LIST_INPUT_LEVELING_LOYALTY_PROGRAM} from "../../utils/input-field-list-static-page";
import {setLoyaltyProgramErrorMessage, setLoyaltyProgramLevelingDetail} from "../../reducers/loyalty-program.reducer";
import {setToolsAlertMessage, setToolsAlertType, setToolsModalVisibility} from "../../reducers/tools.reducer";
import {convertErrorMessage} from "../../utils/general-variable";
import React, {useEffect} from "react";
import FormGeneralComponent from "../../components/static-page/form-general.component";

const Leveling = () => {
    const dispatch = useDispatch()
    const {levelingDetail, loyaltyProgramErrorMessage} = useSelector(state => state.loyaltyProgramReducer)
    const {fetching: getLeveling} = useFetch(API.LOYALTY_PROGRAM_GET_LEVELING)
    const {fetching: updateLeveling, isLoading} = useFetch(API.LOYALTY_PROGRAM_UPDATE_LEVELING)
    let fieldListInput = FIELD_LIST_INPUT_LEVELING_LOYALTY_PROGRAM
    let showLeveling = {
        label: 'Leveling',
        key: 'show_leveling',
        activeText: 'Show',
        inActiveText: 'Hide',
        positionText: 'left'
    }

    const onChange = (key, value) => {
        dispatch(setLoyaltyProgramLevelingDetail({[key]: value}))
    }

    const onSubmitHandler = (e) => {
        e.preventDefault()
        updateLeveling(levelingDetail).then(response => {
            dispatch(setLoyaltyProgramErrorMessage({}))
            dispatch(setToolsModalVisibility({alert: true}))
            dispatch(setToolsAlertType('success'))
            dispatch(setToolsAlertMessage('Leveling Updated'))
            dispatch(setLoyaltyProgramLevelingDetail(response?.data))
        }).catch(err => {
            dispatch(setLoyaltyProgramErrorMessage(convertErrorMessage(err)))
        })
    }

    useEffect(() => {
        getLeveling().then(response => {
            dispatch(setLoyaltyProgramLevelingDetail(response?.data))
        })

        return () => {
            dispatch(setLoyaltyProgramErrorMessage({}))
        }
    }, [])

    return (
        <FormGeneralComponent
            data={levelingDetail}
            switchToggleField={showLeveling}
            fieldList={fieldListInput}
            onChange={onChange}
            onSubmitHandler={onSubmitHandler}
            inputClassName={'grid grid-cols-2 gap-x-16 gap-y-4'}
            errorMessage={loyaltyProgramErrorMessage}
            isLoading={isLoading}
        />
    )
}

export default Leveling
